export const storeViewLocaleFromStoreViewCode = storeViewCode => storeViewCode && storeViewCode.slice(6);

export const storeViewCodeFromStoreViewLocale = suffix => `bahco_${suffix}`;

export const languageFromStoreViewCode = storeViewCode => storeViewCode && storeViewCode.slice(-2);
export const languageFromStoreViewLocale = languageFromStoreViewCode;
